import { RequestService } from '../../../../../common/services/RequestService';
import { STEERING_ARRANGEMENT_GET } from '../../constants';

export const getSteeringArrangementRequest = payload => {
  return RequestService.get(STEERING_ARRANGEMENT_GET);
};
